import type { Game } from 'chessboard/model/game/types';
import type { Board } from 'chessboard/model/board/types';
import type { Modes } from 'modes/config/types';
import type { Queue } from 'utils/queue/config/types';
import type { API } from 'chessboard/api/config/types';
import type { Renderer } from 'chessboard/renderers/config/types';
import type { Core } from 'chessboard/core/config/types';

export namespace StateMachine {
  export interface Model {
    createUpdateParams: CreateUpdateParams;
    getCurrentState: () => States;
    getParams: () => Params;
    states: { [key in States]: Record<string, Function> };
  }

  /**
   * Interfaces below are designed to provide data for TransitionParams
   * so that properties can be partially deconstructed - i.e deconstructed
   * without having to name every parameter, yet not have to assert their
   * presence later on. If there is a better way to do this, please PR.
   */
  interface A {
    UpdateParams: UpdateParams;
  }
  interface B {
    data: any;
  }
  interface C {
    mode: Modes.API.Bound;
  }
  interface D {
    options: Board.Options;
  }
  interface E {
    params: Params;
  }
  interface F {
    queue: Queue.API;
  }
  interface G {
    api: API.Model;
  }
  interface H {
    renderer: Renderer.Model;
  }
  interface I {
    context: Core.Context;
  }
  interface J {
    type: Core.EventType;
  }

  export type TransitionParams = A & B & C & D & E & F & G & H & I & J;

  export type CreateUpdateParams = (params: Params) => UpdateParams;

  export interface Params {
    draggingCoords: Board.Coords | undefined;
    draggingPiece: Board.SanSquare | undefined;
    markingStartSquare: Board.SanSquare | undefined;
    promotionMove: Game.Move.Model | undefined;
    selectedPiece: Board.SanSquare | undefined;
  }

  export enum States {
    AddingMarkings = 'AddingMarkings',
    Idle = 'Idle',
    PieceDragging = 'PieceDragging',
    PieceSelected = 'PieceSelected',
    PromotionAreaShowing = 'PomotionAreaShowing',
  }

  export interface UpdateParams {
    cancelMarkingStartSquare: () => void;
    cancelPromotion: () => void;
    deselectPiece: () => void;
    dragPiece: (coords: Board.Coords, square: Board.SanSquare) => void;
    dropPiece: () => void;
    resetElevatedState: () => void;
    selectPiece: (square: Board.SanSquare) => void;
    setMarkingStartSquare: (square: Board.SanSquare) => void;
    showPromotionArea: (move: Game.Move.Model) => void;
  }
}

export namespace Plugin {
  export const Name = 'core';
}
